import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en_res from './languages/en.json';
import it_res from './languages/it.json';
import cn_res from './languages/cn.json';
import cz_res from './languages/cz.json';
import de_res from './languages/de.json';
import es_res from './languages/es.json';
import fr_res from './languages/fr.json';
import pl_res from './languages/pl.json';
import pt_res from './languages/pt.json';
import rs_res from './languages/rs.json';
import ru_res from './languages/ru.json';
import sk_res from './languages/sk.json';

const resources = {
    en: {
        translation: en_res,
    },
    it: {
        translation: it_res,
    },
    cn: {
        translation: cn_res,
    },
    cz: {
        translation: cz_res,
    },
    de: {
        translation: de_res,
    },
    es: {
        translation: es_res,
    },
    fr: {
        translation: fr_res,
    },
    pl: {
        translation: pl_res,
    },
    pt: {
        translation: pt_res,
    },
    rs: {
        translation: rs_res,
    },
    ru: {
        translation: ru_res,
    },
    sk: {
        translation: sk_res,
    },
};

const options = {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'i18nextLng',
};

const defaultLanguage = 'en';

export const getLanguage = (): string => window.localStorage.getItem(options.lookupLocalStorage)!;

export const changeLanguage = (language: string) => i18n.changeLanguage(language);

export enum ELanguages {
    en = 'en',
    it = 'it',
    cn = 'cn',
    cz = 'cz',
    de = 'de',
    es = 'es',
    fr = 'fr',
    pl = 'pl',
    pt = 'pt',
    rs = 'rs',
    ru = 'ru',
    sk = 'sk',
}

export const languages = {
    [ELanguages.en]: 'English',
    [ELanguages.it]: 'Italian',
    [ELanguages.cn]: 'Chinese',
    [ELanguages.cz]: 'Czech',
    [ELanguages.de]: 'German',
    [ELanguages.es]: 'Spanish',
    [ELanguages.fr]: 'French',
    [ELanguages.pl]: 'Polish',
    [ELanguages.pt]: 'Portuguese',
    [ELanguages.rs]: 'Serbian',
    [ELanguages.ru]: 'Russian',
    [ELanguages.sk]: 'Slovak',
};

export type TLanguages = keyof typeof languages;

export default i18n;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: defaultLanguage,
        debug: true,
        detection: options,
        interpolation: {
            escapeValue: false,
        },
    });

if (!resources[getLanguage() as TLanguages]) {
    i18n.changeLanguage(defaultLanguage);
}
